import { classnames } from '@aibees/shared/utils';
import { Switch, SwitchProps, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { VisibilitySwitchProps as Props } from './types';

export const VisibilitySwitch = memo(
  ({ className, checked, onChange }: Props) => {
    const handleChangeSwitch: SwitchProps['onChange'] = (e) => {
      onChange?.(e.target.checked);
    };

    return (
      <Styled.Wrapper
        className={classnames('VisibilitySwitch', className)}
        sx={SX.root}
      >
        <Typography sx={SX.title}>Share</Typography>
        <Switch
          sx={SX.check}
          checked={checked}
          onChange={handleChangeSwitch}
          size="small"
        />

        <Typography sx={SX.title}>Private</Typography>
      </Styled.Wrapper>
    );
  }
);

VisibilitySwitch.displayName = 'VisibilitySwitch';
